var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.30769231,5.07692308 C8.30769231,6.85817308 6.85817308,8.30769231 5.07692308,8.30769231 C3.29567308,8.30769231 1.84615385,6.85817308 1.84615385,5.07692308 C1.84615385,3.29567308 3.29567308,1.84615385 5.07692308,1.84615385 C6.85817308,1.84615385 8.30769231,3.29567308 8.30769231,5.07692308 Z M12,11.0769231 C12,10.8317308 11.8990385,10.59375 11.7331731,10.4278846 L9.25961538,7.95432692 C9.84375,7.11057692 10.1538462,6.10096154 10.1538462,5.07692308 C10.1538462,2.27163462 7.88221154,0 5.07692308,0 C2.27163462,0 0,2.27163462 0,5.07692308 C0,7.88221154 2.27163462,10.1538462 5.07692308,10.1538462 C6.10096154,10.1538462 7.11057692,9.84375 7.95432692,9.25961538 L10.4278846,11.7259615 C10.59375,11.8990385 10.8317308,12 11.0769231,12 C11.5817308,12 12,11.5817308 12,11.0769231 Z",
    id: "search-id"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 5.785702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "search-mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search-id"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#999999",
    xlinkHref: "#search-id"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d9a440be9b6783881841003c4bda1b7f.svg";
export { ForwardRef as ReactComponent };